import { StoryForm } from "../StoryForm";

export const AddStoryPage = () => {
    return (<StoryForm />)
}